import { safeStorage } from './safe-storage';

const IMPACT_REF_STORAGE_KEY = 'impact_im_ref';

export const persistImpactImRefFromUrl = (): void => {
  const imRef = new URLSearchParams(window.location.search).get('im_ref');
  if (imRef) {
    safeStorage.setItem(IMPACT_REF_STORAGE_KEY, imRef);
  }
};

export const getImpactImRef = (): string | undefined => {
  const imRef =
    new URLSearchParams(window.location.search).get('im_ref') || safeStorage.getItem(IMPACT_REF_STORAGE_KEY);
  return imRef || undefined;
};

export const clearImpactImRef = (): void => {
  safeStorage.removeItem(IMPACT_REF_STORAGE_KEY);
};
